export default __webpack_public_path__ + "static/media/internet2.007b7270.png";